import { render } from "./RequestsReceived.vue?vue&type=template&id=d04909f2&scoped=true"
import script from "./RequestsReceived.vue?vue&type=script&lang=js"
export * from "./RequestsReceived.vue?vue&type=script&lang=js"

import "./RequestsReceived.vue?vue&type=style&index=0&id=d04909f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d04909f2"

export default script